import { useEffect, useState } from "react";
import DashboardLayoutMain from "../../../layout/dashboard/DashboardLayoutMain";
import TitleBtnFragment from "../../../components/fragment/title-btn/TitleBtnFragment";
import "../../../styles/dashboard/users/UserActivitiesIndex.css";
import FilterReusableComp from "../../../components/FilterReusableComp";
import { useDispatch, useSelector } from "react-redux";
import RootState from "../../../redux/type";
import { getAllRolesDrop } from "../../../redux/role";
import { AddAllToList, capitalizeFirstLetter } from "../../../utils/Helper";
import {
  RazorDateTime,
  RazorTable,
  RazorTableRow,
  RazorTextTrim,
  RazorToolTip,
} from "../../../components/razor-reuse";
import PaginationFragment from "../../../components/fragment/pagination/PaginationFragment";
import { getAllAdminUsersActivity } from "../../../redux/users";
import ViewActivityModal from "./modals/ViewActivityModal";
import DateRangeComponent from "../../../components/fragment/date-range/DateRangeComponent";
import { systemRoles } from "../../../utils/roles";
import { ALL_ROUTES } from "../../../routes/AllRoutes";
import { useNavigate } from "react-router-dom";

const UserActivitiesIndex = () => {
  const [filterOneVal, setFilterOneVal] = useState<any>("");
  const navigate = useNavigate();
  const [search, setsearch] = useState<any>("");
  const [filterTwoVal, setFilterTwoVal] = useState<any>("");
  const { user } = useSelector((state: RootState) => state.auth);
  const { loading_users, admin_users_activity } = useSelector(
    (state: RootState) => state.users
  );
  const dispatch = useDispatch();
  const { all_roles_drop } = useSelector((state: RootState) => state.roles);
  const [dateRange, setDateRange] = useState("");

  const [singleChild, setSingleChild] = useState({});
  type modalProps = {
    view: boolean;
  };
  //   const [refreshTable, setRefreshTable] = useState<boolean>(false);
  const [showModal, setShowModal] = useState<modalProps>({
    view: false,
  });

  useEffect(() => {
    if (
      all_roles_drop?.length < 1 &&
      user?.permissions?.includes(systemRoles[23])
    ) {
      dispatch(getAllRolesDrop({}) as any);
    }
  }, []);

  const getListUserRole = (list: any) => {
    if (list?.length > 0) {
      const newList = list?.map((chi: any) => {
        return {
          ...chi,
          label: capitalizeFirstLetter(chi?.label)?.replaceAll("_", " "),
        };
      });

      return AddAllToList(newList, "Roles");
    }
  };

  const selectListTwo = [
    { label: "Login", value: "login" },
    { label: "Update", value: "update" },
    { label: "View", value: "view" },
    { label: "Review", value: "review" },
    { label: "Delete", value: "delete" },
    { label: "Create", value: "create" },
    { label: "Export", value: "export" },
    { label: "All Type", value: "" },
  ];

  const tableHeaderList = [
    "Full Name",
    "Email",
    "Role",
    "User Activity Type",
    "User Activity Detail",
    "Date",
  ];

  const [currentPageVal, setCurrentPage] = useState(1);

  useEffect(() => {
    const obj = {
      page: currentPageVal,
      search: search,
      role: filterOneVal?.name,
      type: filterTwoVal?.value,
      date: dateRange,
    };
    if (
      user?.permissions?.includes(systemRoles[1]) &&
      user?.permissions?.length > 0
    ) {
      dispatch(getAllAdminUsersActivity(obj) as any);
    }
  }, [
    currentPageVal,
    filterOneVal,
    filterTwoVal,
    dateRange,
    search,
    dispatch,
    ,
    user?.permissions,
  ]);

  // useEffect to check if user has permission to view user activities
  useEffect(() => {
    if (
      !user?.permissions?.includes(systemRoles[1]) &&
      user?.permissions?.length > 0
    ) {
      navigate(ALL_ROUTES?.DASHBOARD_OVERVIEW);
    }
  }, []);

  function arrayToString(arr: string[], separator: string = ", "): string {
    return arr.join(separator);
  }

  const getListUserRoleTable = (list: any) => {
    if (list?.length > 0) {
      const newList = list?.map((chi: any) =>
        capitalizeFirstLetter(chi)?.replaceAll("_", " ")
      );

      return arrayToString(newList);
    }
  };

  const resetFilter = () => {
    const obj = {
      page: 1,
      search: "",
      role: "",
      type: "",
      date: "",
    };
    dispatch(getAllAdminUsersActivity(obj) as any);
  };

  const wrapLength = 40;

  return (
    <>
      <DashboardLayoutMain
        loading={
          Object?.keys(admin_users_activity)?.length < 1 && loading_users
        }
        title="Team Activity"
      >
        <div
          //   onClick={() => {
          //     console.log(admin_users_activity);
          //   }}
          className="user-activity-index-wrapper-box"
        >
          {/* title b tn start */}
          <TitleBtnFragment title="User  Activity Log" hideBtn />
          {/* title btn end */}
          {/* filter section start */}
          <FilterReusableComp
            defaultSelectOne="Filter by Role"
            selectOneValue={filterOneVal}
            onSelectOne={(param) => {
              setFilterOneVal(param);
              //   console.log(param);
            }}
            selectOneList={getListUserRole(all_roles_drop)}
            defaultSelectTwo="Action Type"
            selectTwoList={selectListTwo}
            selectTwoValue={filterTwoVal}
            onSelectTwo={(param) => {
              setFilterTwoVal(param);
              //   console.log(param);
            }}
            onSearch={(param: any) => {
              if (String(param)?.length > 2) {
                // const obj = {
                //   search: param,
                // };
                // dispatch(getAllAdminUsersActivity(obj) as any)
                setCurrentPage(1);
                setsearch(param);
              }
              if (String(param)?.length < 1) {
                // dispatch(getAllAdminUsersActivity({}) as any);
                setCurrentPage(1);
                setsearch("");
              }
            }}
            hideExport
            searchPlaceholder="Search for users"
            moreComponents={
              <>
                <DateRangeComponent
                  onSet={(param) => {
                    setDateRange(param);
                  }}
                  value={dateRange}
                  onCancel={() => {
                    setDateRange("");
                    resetFilter();
                  }}
                  // onOpen={}
                />
              </>
            }
          />
          {/* filter section end */}
          {/* table start */}
          <div className="table-section-box">
            <RazorTable headerList={tableHeaderList}>
              {admin_users_activity?.data?.map((chi: any, idx: any) => {
                return (
                  <RazorTableRow
                    loading={loading_users}
                    key={idx}
                    one={RazorTextTrim(chi?.full_name, 25)}
                    two={chi?.email}
                    three={
                      chi?.role?.length > 0
                        ? RazorTextTrim(getListUserRoleTable(chi?.role), 25)
                        : "---"
                    }
                    four={capitalizeFirstLetter(chi?.activity_type)}
                    five={
                      <p className="tooltip-hover-wrap">
                        {RazorTextTrim(chi?.activity_detail, wrapLength)}
                        {chi?.activity_detail?.length > wrapLength && (
                          <RazorToolTip
                            text={chi?.activity_detail}
                            position={`top-center`}
                            color="black-light"
                          />
                        )}
                      </p>
                    }
                    onRowClick={() => {
                      setSingleChild(chi);
                      setShowModal((prev) => {
                        return { ...prev, view: true };
                      });
                    }}
                    six={<RazorDateTime date={chi?.date} />}
                  />
                );
              })}
            </RazorTable>
          </div>
          {/* table end */}
          {/* pagination start */}
          <PaginationFragment
            currentPage={admin_users_activity?.meta?.current_page || 1}
            perPage={admin_users_activity?.meta?.per_page}
            totalPage={admin_users_activity?.meta?.total}
            onPageChange={(num) => {
              setCurrentPage(num);
            }}
            hidePagination={loading_users}
          />
          {/* pagination  end */}
        </div>
      </DashboardLayoutMain>
      {/* modal start here  */}
      <ViewActivityModal
        onClose={() => {
          setShowModal((prev) => {
            return { ...prev, view: false };
          });
        }}
        visible={showModal?.view}
        details={singleChild}
      />
      {/* modal end here */}
    </>
  );
};

export default UserActivitiesIndex;
